import FlowCanvas from "./reactflowchart/FlowCanvas";

interface SystemTestArchitectureProps {
	onClick: (d?: string) => void;
	usecase?: "type" | "effectiveness";
	orgData?: string;
}

const SystemTestArchitecture: React.FC<SystemTestArchitectureProps> = ({
	onClick,
	usecase,
	orgData,
}) => {
	return (
		<div
			className="w-full mx-auto mt-12 bg-[#EAF5FF]"
			style={{ width: "", height: "700px", border: "1px solid #ddd" }}>
			<div className="p-2">
				<FlowCanvas usecase={usecase} onClick={onClick} orgData={orgData} />
			</div>
			{/* Later, you'll filter the boxes based on selectedCategory */}
		</div>
	);
};

export default SystemTestArchitecture;
